import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Page, Shapeable, Slice } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { SliceLayoutBoundary, useEntity, useReady } from '@shapeable/ui';
import { classNames } from '@shapeable/utils';
const cls = classNames('page-layout-strategic-intelligence');
import { CampaignMonitorContactWidget } from '../elements/campaign-monitor-contact-widget';
import { RaiselyDonateWidget } from '../elements/raisely-donate-widget';

// -------- Types -------->

export type SliceRaiselyDonateWidgetProps = Classable & HasChildren & { 
  entity?: Slice;
};

export const SliceRaiselyDonateWidgetDefaultProps: Omit<SliceRaiselyDonateWidgetProps, 'entity'> = {
};

// -------- Child Component Props -------->

// -------- Styles -------->


const ContainerStyles = breakpoints({
  base: css`
  `,
});


const WidgetStyles = breakpoints({
  base: css`
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
  
  Widget: styled(RaiselyDonateWidget)`${WidgetStyles}`,
};

export const SliceRaiselyDonateWidget: Shapeable.FC<SliceRaiselyDonateWidgetProps> = (props) => {
const { className } = props;
  const entity = useEntity(props.entity);

  // const t = useLang();

  const { isReady } = useReady();

  return (

    <My.Container className={cls.name(className)}>
      {
        isReady && (
          <My.Widget
          />
        )
      }
    </My.Container>
  )

};

SliceRaiselyDonateWidget.defaultProps = SliceRaiselyDonateWidgetDefaultProps;
SliceRaiselyDonateWidget.cls = cls;